import { useLocation } from '@tanstack/react-router';
import { resolveScreenName } from './screenMap';
import type { TrackScreenName } from './types';

export function useScreenName(): TrackScreenName | undefined {
  const location = useLocation();
  return resolveScreenName(location.pathname);
}
